import { useDispatch, useSelector } from 'react-redux';
import { selectGLLimit, selectGLAggregateLimit } from '../../../../selectors/application';
import { setLiquorLiabilityCoverage, setCheckedEndorsement } from '../../../../actions/application';
import { formatCurrency } from '../../../../helpers/formatNumber';
import { EndorsementKey } from '../../types';
import EndorsementSummaryCardLayout from '../../../Summary/Endorsements/EndorsementSummaryCardLayout';

const LiquorLiabilitySummaryCard = ({ value }: { value: any }) => {
  const dispatch = useDispatch();
  const glLimit = useSelector(selectGLLimit) || 0;
  const glAggregateLimit = useSelector(selectGLAggregateLimit) || 0;

  const coverageInfo = [
    { coverage: 'Per Claim Limit', limit: formatCurrency(glLimit) },
    { coverage: 'Yearly Limit', limit: formatCurrency(glAggregateLimit) },
  ];

  const handleRemove = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.LiquorLiabilityEndorsement, false));
    dispatch(setLiquorLiabilityCoverage(null));
  };

  const handleRestore = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.LiquorLiabilityEndorsement, true));
    dispatch(setLiquorLiabilityCoverage(value));
  };

  return (
    <EndorsementSummaryCardLayout
      label="Liquor Liability Coverage"
      coverageInfo={coverageInfo}
      onRemove={handleRemove}
      onRestore={handleRestore}
    />
  );
};

export default LiquorLiabilitySummaryCard;
